import { Button } from '@alf/uikit';
import { Icon } from '@namespace/icons2';
import useOpenChat from '../../hooks/useOpenChat';

import styles from './index.module.css';

export const FixedChatButton = () => {
  const { openChat } = useOpenChat();
  return (
    <Button
      onClick={openChat}
      intent="primary"
      iconOnly={true}
      actionType="color2"
      className={styles.general}
      size="xl"
      iconLeft={<Icon name="icons/user_menu/person_feedback" />}
    />
  );
};
